import React, { useEffect } from "react";
import { DEFAULT_LOGO, GLOWS } from "./LogoRevealBg";
import { playWhoosh } from "../lib/whoosh";

// Qué mostrar en la bienvenida: foto/logo del cliente (por defecto), logo propio o UAICARD.
export const splashMedia = (p) => {
  const mode = p?.splashLogo || "client";
  const prof = p?.profile || {};
  const bgLogo = p?.background?.logo;
  const isVid = prof.avatarType === "video" || /\.(mp4|webm|mov)/i.test(prof.avatar || "");
  if (mode === "client" && prof.avatar && !isVid) return { photo: prof.avatar };
  if (mode === "custom" && bgLogo) return { logo: bgLogo };
  if (mode === "uaicard") return { logo: DEFAULT_LOGO };
  return { logo: bgLogo || DEFAULT_LOGO };
};

// Entrada: logo/foto en 3D con destello; al salir hace zoom y se "transforma" en el portafolio.
const WelcomeSplash = ({ logo, photo, glow = "blue", exiting, sound, pending }) => {
  useEffect(() => {
    if (exiting && sound) playWhoosh();
  }, [exiting, sound]);
  const src = logo || DEFAULT_LOGO;
  const mask = { WebkitMaskImage: `url("${src}")`, maskImage: `url("${src}")` };
  return (
    <div className={`sp-root lr-${GLOWS[glow] ? glow : "blue"} ${exiting ? "sp-exit" : ""}`} data-testid="welcome-splash">
      <div className="sp-glow" />
      {pending ? null : photo ? (
        <div className="sp-logo sp-photo" data-testid="welcome-splash-photo">
          <img src={photo} alt="" draggable={false} />
          <div className="sp-shine sp-shine-round" />
        </div>
      ) : (
        <div className="sp-logo">
          <img src={src} alt="" draggable={false} />
          <div className="sp-shine" style={mask} />
        </div>
      )}
    </div>
  );
};

export default WelcomeSplash;
